import Stack from '@mui/material/Stack';

import StyledIconContainer from '@webclient/components/settings/components/tabs/search/components/row/styles';

import { Text } from '@knowz/knowz-ui';

type Props = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  children?: React.ReactNode;
  direction?: 'row' | 'column';
};

export default function FieldGroup({
  direction = 'row',
  icon,
  title,
  description,
  children,
}: Props) {
  return (
    <Stack
      width="100%"
      gap={2}
      direction={direction}
      alignItems="start"
    >
      <Stack
        direction="row"
        gap={2}
        alignItems="flex-start"
        flexGrow={1}
      >
        <StyledIconContainer>{icon}</StyledIconContainer>

        <Stack
          gap={1}
          flex={1}
        >
          <Text variant="textMd">{title}</Text>
          {description && (
            <Text
              variant="textSm"
              color="grey"
            >
              {description}
            </Text>
          )}
        </Stack>
      </Stack>

      {children}
    </Stack>
  );
}
